module.exports = {
      id: "pre-blue-bike-paths-usage",
      viewBox: "0 0 44 32",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#pre-blue-bike-paths",
      toString: function () {
        return this.url;
      }
    }